
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../../components/feature/Header';
import BottomNavigation from '../../components/feature/BottomNavigation';

export default function OrderConfirmationPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [orderDetails, setOrderDetails] = useState<any>(null);

  useEffect(() => {
    // الحصول على تفاصيل الطلب من state أو localStorage
    const { orderNumber, total } = location.state || {};
    
    if (orderNumber) {
      setOrderDetails({
        orderNumber,
        total,
        estimatedDelivery: new Date(Date.now() + 2 * 60 * 60 * 1000).toLocaleString('ar-SA', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      });
    } else {
      // إذا لم توجد تفاصيل، العودة للرئيسية
      navigate('/');
    }
  }, [location.state, navigate]);

  if (!orderDetails) {
    return (
      <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center">
        <div className="text-center">
          <i className="ri-loader-4-line animate-spin text-4xl text-[#D4AF37] mb-4"></i>
          <p className="text-[#777777]">جاري تحميل تفاصيل الطلب...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Header cartItemsCount={0} />
      
      <main className="pt-20 pb-20 px-4">
        {/* Success Animation */}
        <div className="text-center mb-8">
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 animate-pulse">
            <i className="ri-check-line text-4xl text-green-600"></i>
          </div>
          
          <h1 className="text-2xl font-bold text-[#333333] mb-2" dir="rtl">
            تم تأكيد طلبك بنجاح!
          </h1>
          
          <p className="text-[#777777] mb-6" dir="rtl">
            شكراً لك على ثقتك في متجر عبدالرحمن للقهوة الفاخرة
          </p>
        </div>

        {/* Order Details Card */}
        <div className="bg-white rounded-xl p-6 shadow-md mb-6">
          <h3 className="text-lg font-bold text-[#333333] mb-4 text-center" dir="rtl">
            تفاصيل الطلب
          </h3>
          
          <div className="space-y-4" dir="rtl">
            <div className="flex justify-between items-center py-3 border-b border-gray-100">
              <span className="text-[#777777]">رقم الطلب</span>
              <span className="font-bold text-[#4B2E05]">#{orderDetails.orderNumber}</span>
            </div>
            
            <div className="flex justify-between items-center py-3 border-b border-gray-100">
              <span className="text-[#777777]">المبلغ الإجمالي</span>
              <span className="font-bold text-[#4B2E05]">{orderDetails.total} ر.س</span>
            </div>
            
            <div className="flex justify-between items-center py-3 border-b border-gray-100">
              <span className="text-[#777777]">حالة الطلب</span>
              <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                مؤكد
              </span>
            </div>
            
            <div className="flex justify-between items-start py-3">
              <span className="text-[#777777]">وقت التوصيل المتوقع</span>
              <span className="font-medium text-[#333333] text-left">
                {orderDetails.estimatedDelivery}
              </span>
            </div>
          </div>
        </div>

        {/* Delivery Timeline */}
        <div className="bg-white rounded-xl p-6 shadow-md mb-6">
          <h3 className="text-lg font-bold text-[#333333] mb-4 text-right" dir="rtl">
            مراحل التوصيل
          </h3>
          
          <div className="space-y-4" dir="rtl">
            <div className="flex items-center">
              <div className="w-8 h-8 bg-[#D4AF37] rounded-full flex items-center justify-center ml-4">
                <i className="ri-check-line text-white text-sm"></i>
              </div>
              <div>
                <h4 className="font-medium text-[#333333]">تم استلام الطلب</h4>
                <p className="text-sm text-[#777777]">تم تأكيد طلبك بنجاح</p>
              </div>
            </div>
            
            <div className="flex items-center">
              <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center ml-4">
                <i className="ri-time-line text-gray-500 text-sm"></i>
              </div>
              <div>
                <h4 className="font-medium text-[#777777]">جاري التحضير</h4>
                <p className="text-sm text-[#777777]">سيتم تحضير طلبك قريباً</p>
              </div>
            </div>
            
            <div className="flex items-center">
              <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center ml-4">
                <i className="ri-truck-line text-gray-500 text-sm"></i>
              </div>
              <div>
                <h4 className="font-medium text-[#777777]">قيد التوصيل</h4>
                <p className="text-sm text-[#777777]">في الطريق إليك</p>
              </div>
            </div>
            
            <div className="flex items-center">
              <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center ml-4">
                <i className="ri-home-line text-gray-500 text-sm"></i>
              </div>
              <div>
                <h4 className="font-medium text-[#777777]">تم التسليم</h4>
                <p className="text-sm text-[#777777]">وصل طلبك بأمان</p>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <div className="bg-[#D4AF37]/10 rounded-xl p-6 mb-6">
          <h3 className="text-lg font-bold text-[#333333] mb-4 text-right" dir="rtl">
            تحتاج مساعدة؟
          </h3>
          
          <div className="space-y-3" dir="rtl">
            <div className="flex items-center">
              <i className="ri-phone-line text-[#D4AF37] text-xl ml-3"></i>
              <div>
                <h4 className="font-medium text-[#333333]">اتصل بنا</h4>
                <p className="text-sm text-[#777777]">920012345</p>
              </div>
            </div>
            
            <div className="flex items-center">
              <i className="ri-whatsapp-line text-[#D4AF37] text-xl ml-3"></i>
              <div>
                <h4 className="font-medium text-[#333333]">واتساب</h4>
                <p className="text-sm text-[#777777]">متاح 24/7</p>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={() => navigate('/orders')}
            className="w-full bg-[#D4AF37] text-white py-4 rounded-lg font-bold text-lg hover:bg-[#B8941F] transition-colors"
          >
            تتبع الطلب
          </button>
          
          <button
            onClick={() => navigate('/')}
            className="w-full bg-white border-2 border-[#D4AF37] text-[#D4AF37] py-4 rounded-lg font-bold text-lg hover:bg-[#D4AF37]/5 transition-colors"
          >
            متابعة التسوق
          </button>
        </div>

        {/* Thank You Message */}
        <div className="text-center mt-8 p-6 bg-gradient-to-r from-[#4B2E05] to-[#6B4423] rounded-xl">
          <h3 className="text-white text-xl font-bold mb-2" dir="rtl">
            شكراً لاختيارك عبدالرحمن
          </h3>
          <p className="text-white/90 text-sm" dir="rtl">
            نتطلع لخدمتك مرة أخرى قريباً
          </p>
        </div>
      </main>

      <BottomNavigation />
    </div>
  );
}
